<template>
<div class="qa">
    <h1>よくある質問</h1>
    <el-row>
        <QACard
            q = "「AI人数カウンター」は何ができますか?"
            a = "カメラが検知した人数をAIがリアルタイムでカウントし、カウントされた人数・密集度情報を確認することができます。
            お客様が設定した基準値以上の人数をカメラが検知すると、Webアプリーケーション画面にアラートを表示し、
            人々が密集していることを知らせます。また、過去のカウント人数・密集度情報の確認や、
            カウント人数・密集度情報をCSV形式で出力することもできます。"
        ></QACard>
    </el-row>
    <!--<el-row>-->
    <!--    <QACard-->
    <!--        q = "<Question>"-->
    <!--        a = "<Answer>"-->
    <!--    ></QACard>-->
    <!--</el-row>-->
    <!--<el-row>-->
    <!--    <QACard-->
    <!--        q = "<Question>"-->
    <!--        a = "<Answer>"-->
    <!--    ></QACard>-->
    <!--</el-row>-->
    <!--<el-row type="flex" justify="center">-->
    <!--    <span>詳細は<el-link type="primary" :underline="true">取扱説明書</el-link>をご確認ください。</span>-->
    <!--</el-row>-->
</div>
</template>

<script>
import QACard from '@/components/option/QACard.vue';

export default {
    components: {
      QACard,
    },
};

</script>

<style scoped>
h1 {
    font-size: 20px;
}
</style>